import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface PreviewTitleProps {
  addressLine1: string;
  addressLine2: string;
  price: string;
  badge?: ReactNode;
}

export default function PreviewTitle({
  addressLine1,
  addressLine2,
  price,
  badge,
}: PreviewTitleProps) {
  return (
    <Box sx={{ mb: 2 }}>
      {badge && <Box sx={{ mb: 1 }}>{badge}</Box>}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 0.25,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '24px', md: '32px', lg: '40px' },
          }}
          variant="h3"
          fontWeight={700}
        >
          {addressLine1}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '24px', md: '32px', lg: '40px' },
          }}
          variant="h3"
          fontWeight={700}
        >
          {price}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {addressLine2}
      </Typography>
    </Box>
  );
}
